export const ACRONYM_TABLE_USER_INPUT_REQUEST = 'ACRONYM_TABLE_USER_INPUT_REQUEST';
export const ACRONYM_TABLE_USER_INPUT_SUCCESS = 'ACRONYM_TABLE_USER_INPUT_SUCCESS';
export const ACRONYM_TABLE_USER_INPUT_FAIL = 'ACRONYM_TABLE_USER_INPUT_FAIL';